/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import dayjs from "dayjs";
import Config from "data/config";
import { useSimWebpage } from "hooks/use-sim-webpage";

const DISPLAY_FORMAT = Config.dates.general_short;

/**
 * 
 * @param {string} dateString
 * @param {string} format
 */
const formatDate = (dateString, format) => {
    let formattedDate = "";

    if (dateString) {
        const dateFormat = format && format !== "field.format.none" ? format : DISPLAY_FORMAT;
        formattedDate = dayjs.utc(dateString).local().format(dateFormat);
    }

    return formattedDate;
};

const RecentNewsItem = (props) => {
    const showDescription = props?.showDescription || false;
    const webpageGuid = props.webpage?.webpage || props.webpage?.guid;
    const { webpage } = useSimWebpage(webpageGuid);
    
    const title = webpage?.nav_title || webpage?.title || "";
    const publishedAt = webpage?.published_at;
    const path = webpage?.path;
    const description = webpage?.description;
    
    const formattedDate = formatDate(publishedAt);
    
    const handleClick = () => {
        if (path) {
            const url = `${Config.previewUrl}${path}`;
            window.open(url, "_blank");
        }
    };
    
    return (
        <div 
            className={`simplicity-news-highlights-recent-news-item${path ? " simplicity-news-highlights-recent-news-item-clickable" : ""}`}
            onClick={handleClick}
        >
            <div className="simplicity-news-highlights-recent-news-item-content">
                {title && (
                    <div className="simplicity-news-highlights-recent-news-item-title">
                        {title}
                    </div>
                )}
                {showDescription && (
                    <div className="simplicity-news-highlights-recent-news-item-description">
                        {description}
                    </div>
                )}
                {formattedDate && (
                    <div className="simplicity-news-highlights-recent-news-item-date">
                        {formattedDate}
                    </div>
                )}
            </div>
        </div>
    );
};

RecentNewsItem.displayName = "RecentNewsItem";
export { RecentNewsItem };
